var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as templatesAPI from '@debbie/cortex/dist/api/templates';
import { Button, Modal, Table } from '../..';
import THEME from '../../../theme';
import { StateStyled, TypeStyled } from '../Templates';
const VersionsModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [versions, setVersions] = useState([]);
    useEffect(() => {
        props.defaultTemplate && getVersions(props.templateId);
    }, []);
    const getVersions = (templateId) => __awaiter(void 0, void 0, void 0, function* () {
        const versions = yield templatesAPI.getTemplateVersions(templateId, props.ac, props.selectedLanguage);
        setVersions(versions);
    });
    return (React.createElement(Modal, { header: lang.templates.versions, onToggle: props.toggleVersionsModal },
        React.createElement(Table, null,
            React.createElement("tr", null,
                React.createElement("th", null, lang.templates.state),
                React.createElement("th", null, lang.templates.type),
                React.createElement("th", null, lang.templates.savedAt),
                React.createElement("th", null),
                React.createElement("th", null)),
            versions
                .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                .map((template) => (React.createElement("tr", { key: `${template.templateId}-${template.versionId}` },
                React.createElement("td", null,
                    React.createElement(StateStyled, { state: template.state },
                        template.state,
                        ' ')),
                React.createElement("td", null,
                    React.createElement(TypeStyled, { type: template.type },
                        template.type,
                        " ")),
                React.createElement("td", null, moment(template.createdAt).format(THEME.DATE_FORMAT_LONG)),
                React.createElement("td", null,
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => {
                            props.loadInEditor(template);
                            props.toggleVersionsModal();
                        } }, lang.templates.view))))))));
};
export default VersionsModal;
//# sourceMappingURL=VersionsModal.js.map